export default __webpack_public_path__ + "static/media/portvideo.3b1df2ce.mp4";